import { FormikContext, useFormik } from 'formik'
import { forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'

import { createProjectInitialValues } from './helpers/create-project-initial-values'
import { CreateProjectValidationSchema } from './validators/create-project-validation-schema'
import { PureInput } from '../../../../common/ui/pure-input/pure-input'
import { Project } from '../../../../entities/projects/types/project.types'

type ObjectModalProps = {
  onSubmit: (values: Omit<Project, 'id' | 'createdAt' | 'updatedAt'>) => void
  initialValues: Project | null
}

export const ProjectModal = forwardRef(({ onSubmit, initialValues }: ObjectModalProps, ref) => {
  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: createProjectInitialValues(initialValues),
    validationSchema: CreateProjectValidationSchema(),
    onSubmit: (values: any) => {
      onSubmit(values)
      formik.resetForm()
    },
  })

  useImperativeHandle(ref, () => ({
    submit: formik.submitForm,
  }))

  return (
    <FormikContext.Provider value={formik as any}>
      <form
        className="row"
        onSubmit={formik.handleSubmit}
      >
        <div className="col-12 col-md-3 px-1">
          <p className="mb-1">{t('settings.projects.name')}</p>
          <PureInput
            {...formik.getFieldProps('name')}
            error={formik.errors.name as string[]}
            placeholder={t('settings.projects.namePlaceholder')}
          />
        </div>
      </form>
    </FormikContext.Provider>
  )
})
